import React from "react";
import { motion } from "framer-motion";
import textutils from "../assets/textutils_project.png";
const Card2 = () => {
  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      class="max-w-xl bg-white rounded-lg border border-gray-200 shadow-lg bg-gray-100 dark:border-gray-700 my-8"
    >
      <a href="https://text-utils-nu-two.vercel.app/" target="_blank" rel="noopener noreferrer">
        <img
          class="rounded-t-lg w-full"
          src={textutils}
          alt="TextUtils project home page"
        />
      </a>
      <div class="p-5">
        <a href="https://github.com/nick3948/TextUtils" target="_blank" rel="noopener noreferrer">
          <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black hover:text-blue-500 transition-colors duration-300 cursor-pointer">
            Text Utils
          </h5>
        </a>
        <p class="mb-3 font-normal text-gray-700 dark:text-black-400">
        Built a responsive text utility web application using React that allows users to perform various text operations including uppercase/lowercase conversion, JSON/XML formatting, word and character counting, and more. Designed with a clean, intuitive UI to improve productivity and user experience.
        </p>
        
      </div>
    </motion.div>
  );
};

export default Card2;
